<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 md6 offset-md3>
        <v-card>
          <v-card-title>
            <v-layout row>
              <div>
                <span>
                  <v-avatar size="42px">
                    <img :src="post.author.image" class="mr-3">
                  </v-avatar>
                </span>
              </div>
              <div>
                <v-layout column>
                  <div>{{ post.author.given_name }} {{post.author.family_name}} {{post.author.ext_name}}</div>
                  <div class="grey--text caption">{{post.edited ? post.updated_at : post.created_at}} {{post.edited ? '(edited)' : ''}}</div>
                </v-layout>
              </div>
            </v-layout>
            <v-spacer></v-spacer>
            <v-menu offset-y lazy v-if="this.$store.getters.GET_USER_DETAILS.user_id === post.author.user_id">
              <v-btn flat icon color="grey darken-2" slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="openEditDialog">
                  <v-list-tile-title>Edit</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="deleteDialog = true">
                  <v-list-tile-title>Delete</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <span>{{ post.post_content }}</span>
          </v-card-text>
          <v-card-text class="grey lighten-4" v-if="post.comments.length !== 0">
            <div v-if="post.comments.length > 1">
              <p @click="collapsed = false" class="caption comment-caption" v-if="collapsed !== false">View {{ post.comments.length }} comments..</p>
              <p @click="collapsed = true" class="caption comment-caption" v-else>Collapse comments..</p>
            </div>
            <post-comment
              v-for="(comment, i) in !collapsed ? post.comments : [post.comments[post.comments.length - 1]]"
              :key="i"
              :comment="comment"
            ></post-comment>
          </v-card-text>
          <v-card-text class="grey lighten-3 ">
            <span class="caption comment-caption" v-if="!commentStatus" @click="commentStatus = true">Write a comment...</span>
            <v-layout row wrap v-else>
              <v-flex xs12 md8>
                <v-text-field
                  label="Your comment..."
                  v-model="commentText"
                  autofocus
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout row>
                  <v-btn flat color="red" @click="commentStatus = false" :disabled="loading">Cancel</v-btn>
                  <v-btn dark color="green" @click="comment" :loading="loading" >Comment</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- EDIT -->
    <v-dialog v-model="editDialog" persistent width="700px">
      <v-card>
        <v-card-text>
          <v-text-field
            label="Edit your post..."
            multi-line
            rows="1"
            v-model="editedText"
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="editDialog = false" :disabled="loading">Cancel</v-btn>
          <v-btn class="elevation-0" dark color="green" :loading="loading" @click="editPost(post.post_id)">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog v-model="deleteDialog" persistent width="300px">
      <v-card>
        <v-card-title class="headline">Delete this post?</v-card-title>
        <v-card-text>Comments will also be deleted.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteDialog = false" :disabled="loading">Cancel</v-btn>
          <v-btn class="elevation-0" dark color="red" :loading="loading" @click="deletePost(post.post_id)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import PostComment from './PostComment.vue'
export default {
  components: {
    PostComment
  },
  props: ['post'],
  data(){
    return {
      commentStatus: false,
      commentText: '',
      editedText: '',
      loading: false,
      editDialog: false,
      deleteDialog: false,
      collapsed: true
    }
  },
  methods: {
    async comment(){
      try{
        this.loading = true
        let response = await axios.post('/api/class/post/comment', {
          post_id: this.post.post_id,
          comment: this.commentText
        }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})
        this.$store.dispatch('student/FETCH_POSTS', {class_id: this.$route.params.id})
        this.restart()
      }catch(e){
        this.loading = false
        console.log(e)
      }
    },
    restart(){
      this.loading = false
      this.commentStatus = false
      this.commentText = ''
      this.editedText = ''
      this.editDialog = false
    },
    async editPost(id){
      try{
        this.loading = true
        let response = await axios.post('/api/class/post/update', {
          post_id: id,
          post_content: this.editedText
        }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})
        this.$store.dispatch('student/FETCH_POSTS', {class_id: this.$route.params.id})
        this.restart()
      }catch(e){
        this.loading = false
        console.log(e)
      }
    },
    async deletePost(id){
      try{
        this.loading = true
        let response = await axios.post('/api/class/post/delete', null, { 
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` 
          },
          params: {
            ids: [id]
          }
        })
        this.$store.dispatch('student/FETCH_POSTS', {class_id: this.$route.params.id})
        this.restart()
      }catch(e){
        this.loading = false
        console.log(e)
      }
    },
    openEditDialog(){
      this.editDialog = true
      this.editedText = this.post.post_content
    }
  }
}
</script>

<style scoped>
.comment-caption:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Student/Classroom/Post.vue